export const getFormattedAmountValue = (amount: number): string => {
  const rounded = Math.round(amount * 100) / 100;
  return rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(2);
};
